import clx from 'classnames';
import { ReactNode } from 'react';

const TabsContainer = ({ className, children }: { className?: string; children: ReactNode }) => (
  <ul className={clx('flex flex-row w-full max-w-full gap-1 sm:gap-2 px-2 sm:px-3 overflow-x-auto', className)}>
    {children}
  </ul>
);

export default TabsContainer;
